// extracted by mini-css-extract-plugin
module.exports = {"vertical_nav__redLink":"VerticalNav_vertical_nav__redLink__304jf","activeNav":"VerticalNav_activeNav__3qx-v"};